module.exports = __webpack_public_path__ + "static/media/4.bed5042b.jpg";